// The moderation categories, apart from their schemas (Classification.ts): route guards and other
// code on every page import them without bundling the classification and policy model.
export const CLASSIFICATION_CATEGORIES = [
  "sexual",
  "violence",
  "self-harm",
  "harassment",
  "hate",
  "criminal-activity",
  "personal-information",
  "profanity",
] as const;

export const MODERATION_POLICY_CATEGORIES = CLASSIFICATION_CATEGORIES;
